// extracted by mini-css-extract-plugin
export default {"input-search":"input-search","searchbox":"searchbox","empty-searchbox":"empty-searchbox","left-icon":"left-icon","close-span":"close-span","right-icon":"right-icon"};